import { createStore } from "zustand/vanilla";
import { ok, err, conflict } from "@pack-it-up/shared";
import { importTemplates } from "@pack-it-up/core";
export const createImportPickerStore = (deps) => {
    return createStore((set, get) => ({
        selected: [],
        needsConfirm: false,
        error: null,
        toggle(templateId) {
            const sel = get().selected;
            set({ selected: sel.includes(templateId) ? sel.filter((t) => t !== templateId) : [...sel, templateId] });
        },
        clear() {
            set({ selected: [], needsConfirm: false });
        },
        async importInto(trip, current, templates, opts) {
            const reimport = templates.some((t) => trip.importedTemplateIds.includes(t.templateId));
            if (reimport && !opts?.confirm) {
                set({ needsConfirm: true });
                return err(conflict("This template is already on the trip — import again?"));
            }
            const plan = importTemplates(trip, templates, current, deps.actor);
            deps.applyImportPlan(plan, trip.id);
            set({ needsConfirm: false, selected: [], error: null });
            return ok(plan);
        },
    }));
};
//# sourceMappingURL=importPickerStore.js.map